/* Kilo — Subscribe & Save.
   One-time = normal add-to-cart (opens the cart drawer).
   Monthly / Bi-weekly = route the customer to the Checkout Champ funnel URL,
   passing the selected variant + cycle. Prices/savings stay in sync with the
   selected caviar amount. If no funnel URL is configured yet, the Subscribe
   button shows the "coming soon" note instead of navigating. */
(function () {
  function init() {
    var root = document.querySelector('[data-kilo-sub]');
    var productRoot = document.querySelector('[data-kilo-product]');
    if (!root || !productRoot) return;

    var jsonEl = productRoot.querySelector('[data-kilo-product-json]');
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var moneyFormat = productRoot.dataset.moneyFormat || '${{amount}}';
    var monthlyPct = parseFloat(root.getAttribute('data-monthly-pct')) || 0;
    var biweeklyPct = parseFloat(root.getAttribute('data-biweekly-pct')) || 0;
    var submitButton = productRoot.querySelector('[data-kilo-submit]');
    var note = root.querySelector('[data-sub-note]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[name="kilo-purchase-type"]'));
    var options = Array.prototype.slice.call(root.querySelectorAll('.kilo-sub__option'));

    var pctByCycle = { onetime: 0, monthly: monthlyPct, biweekly: biweeklyPct };
    var selectedType = 'onetime';
    var selectedUrl = '';
    var currentVariantId = product.variants[0] ? product.variants[0].id : '';

    function formatMoney(cents) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    function escapeName(name) {
      return (window.CSS && CSS.escape) ? CSS.escape(name) : name;
    }

    function currentVariant() {
      var selected = product.options.map(function (name) {
        var input = productRoot.querySelector('[name="options[' + escapeName(name) + ']"]:checked');
        return input ? input.value : null;
      });
      return product.variants.find(function (v) {
        return v.options.every(function (val, idx) {
          return !selected[idx] || selected[idx] === val;
        });
      }) || product.variants[0] || null;
    }

    function updatePrices() {
      var v = currentVariant();
      if (!v) return;
      currentVariantId = v.id;
      var base = v.price;
      root.querySelectorAll('[data-sub-price]').forEach(function (el) {
        var cycle = el.getAttribute('data-sub-price');
        var pct = pctByCycle[cycle] || 0;
        var price = Math.round(base * (100 - pct) / 100);
        el.textContent = formatMoney(price);
      });
      root.querySelectorAll('[data-sub-was]').forEach(function (el) {
        el.textContent = formatMoney(base);
      });
      applyCtaLabel();
    }

    function applyCtaLabel() {
      if (!submitButton) return;
      var checked = root.querySelector('input[name="kilo-purchase-type"]:checked');
      if (!checked || checked.value === 'onetime') {
        submitButton.textContent = submitButton.dataset.onetimeLabel || 'Add to Cart';
        submitButton.classList.remove('is-subscribe');
      } else if (!submitButton.disabled) {
        submitButton.textContent = checked.getAttribute('data-sub-label') || 'Subscribe';
        submitButton.classList.add('is-subscribe');
      }
    }

    function onRadioChange() {
      var checked = root.querySelector('input[name="kilo-purchase-type"]:checked');
      selectedType = checked ? checked.value : 'onetime';
      selectedUrl = checked ? (checked.getAttribute('data-sub-url') || '') : '';
      options.forEach(function (o) {
        o.classList.toggle('is-selected', !!checked && o.contains(checked));
      });
      if (note) note.hidden = true;
      applyCtaLabel();
    }

    radios.forEach(function (r) { r.addEventListener('change', onRadioChange); });

    // Recompute after the theme's own variant handler has run.
    productRoot.querySelectorAll('[data-kilo-option-input]').forEach(function (input) {
      input.addEventListener('change', function () { setTimeout(updatePrices, 0); });
    });

    if (submitButton) {
      submitButton.dataset.onetimeLabel = submitButton.textContent.trim() || 'Add to Cart';
      // Click fires before the form's submit; preventing default cancels the
      // add-to-cart entirely for subscription purchases.
      submitButton.addEventListener('click', function (e) {
        if (selectedType === 'onetime') return; // let normal add-to-cart + drawer run
        e.preventDefault();
        e.stopPropagation();
        if (!selectedUrl) {
          if (note) note.hidden = false;
          return;
        }
        var sep = selectedUrl.indexOf('?') > -1 ? '&' : '?';
        var url = selectedUrl + sep +
          'variant=' + encodeURIComponent(currentVariantId) +
          '&cycle=' + encodeURIComponent(selectedType);
        window.location.href = url;
      }, true);
    }

    updatePrices();
    onRadioChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
